module.exports = __webpack_public_path__ + "img/dash.14b1982d.svg";